var styles = {"priceSection":"index-module_priceSection__CPChZ","price":"index-module_price__Tc-xk","icons":"index-module_icons__Ir6Hv","shippingIcon":"index-module_shippingIcon__DYa7h"};

export { styles as default };
//# sourceMappingURL=index.module.css.js.map
